/**
 * Catalogue of TTS voices supported by the Wildix PBX's text-to-speech
 * engine. Source: the voice list exposed by the PBX admin UI.
 *
 * Used to:
 *   - render a grouped <select> in the web admin
 *   - validate inbound `tts_voice` / `tts_voice_default` API values
 */
export const TTS_VOICES = Object.freeze([
    // US English
    { value: 'Danielle', label: 'Danielle (US English)', language: 'US English' },
    { value: 'Gregory', label: 'Gregory (US English)', language: 'US English' },
    { value: 'Joanna', label: 'Joanna (US English)', language: 'US English' },
    { value: 'Ruth', label: 'Ruth (US English)', language: 'US English' },
    { value: 'Kevin', label: 'Kevin (US English)', language: 'US English' },
    { value: 'Salli', label: 'Salli (US English)', language: 'US English' },
    { value: 'Matthew', label: 'Matthew (US English)', language: 'US English' },
    { value: 'Kimberly', label: 'Kimberly (US English)', language: 'US English' },
    { value: 'Kendra', label: 'Kendra (US English)', language: 'US English' },
    { value: 'Justin', label: 'Justin (US English)', language: 'US English' },
    { value: 'Joey', label: 'Joey (US English)', language: 'US English' },
    { value: 'Ivy', label: 'Ivy (US English)', language: 'US English' },
    { value: 'Stephen', label: 'Stephen (US English)', language: 'US English' },
    // British English
    { value: 'Amy', label: 'Amy (British English)', language: 'British English' },
    { value: 'Emma', label: 'Emma (British English)', language: 'British English' },
    { value: 'Brian', label: 'Brian (British English)', language: 'British English' },
    { value: 'Arthur', label: 'Arthur (British English)', language: 'British English' },
    // Other English variants
    { value: 'Olivia', label: 'Olivia (Australian English)', language: 'Australian English' },
    { value: 'Russell', label: 'Russell (Australian English)', language: 'Australian English' },
    { value: 'Nicole', label: 'Nicole (Australian English)', language: 'Australian English' },
    { value: 'Kajal', label: 'Kajal (Indian English)', language: 'Indian English' },
    { value: 'Raveena', label: 'Raveena (Indian English)', language: 'Indian English' },
    { value: 'Aditi', label: 'Aditi (Indian English)', language: 'Indian English' },
    { value: 'Jasmine', label: 'Jasmine (Singaporean English)', language: 'Singaporean English' },
    { value: 'Aria', label: 'Aria (New Zealand English)', language: 'New Zealand English' },
    { value: 'Ayanda', label: 'Ayanda (South African English)', language: 'South African English' },
    { value: 'Niamh', label: 'Niamh (Irish English)', language: 'Irish English' },
    { value: 'Geraint', label: 'Geraint (Welsh English)', language: 'Welsh English' },
    // Spanish
    { value: 'Pedro', label: 'Pedro (US Spanish)', language: 'US Spanish' },
    { value: 'Lupe', label: 'Lupe (US Spanish)', language: 'US Spanish' },
    { value: 'Miguel', label: 'Miguel (US Spanish)', language: 'US Spanish' },
    { value: 'Penelope', label: 'Penélope (US Spanish)', language: 'US Spanish' },
    { value: 'Mia', label: 'Mia (Mexican Spanish)', language: 'Mexican Spanish' },
    { value: 'Andres', label: 'Andrés (Mexican Spanish)', language: 'Mexican Spanish' },
    { value: 'Lucia', label: 'Lucia (Castilian Spanish)', language: 'Castilian Spanish' },
    { value: 'Sergio', label: 'Sergio (Castilian Spanish)', language: 'Castilian Spanish' },
    { value: 'Conchita', label: 'Conchita (Castilian Spanish)', language: 'Castilian Spanish' },
    { value: 'Enrique', label: 'Enrique (Castilian Spanish)', language: 'Castilian Spanish' },
    // Other Romance
    { value: 'Arlet', label: 'Arlet (Catalan)', language: 'Catalan' },
    { value: 'Thiago', label: 'Thiago (Brazilian Portuguese)', language: 'Brazilian Portuguese' },
    { value: 'Vitoria', label: 'Vitória (Brazilian Portuguese)', language: 'Brazilian Portuguese' },
    { value: 'Camila', label: 'Camila (Brazilian Portuguese)', language: 'Brazilian Portuguese' },
    { value: 'Ricardo', label: 'Ricardo (Brazilian Portuguese)', language: 'Brazilian Portuguese' },
    { value: 'Ines', label: 'Inês (Portuguese)', language: 'Portuguese' },
    { value: 'Cristiano', label: 'Cristiano (Portuguese)', language: 'Portuguese' },
    { value: 'Gabrielle', label: 'Gabrielle (Canadian French)', language: 'Canadian French' },
    { value: 'Chantal', label: 'Chantal (Canadian French)', language: 'Canadian French' },
    { value: 'Liam', label: 'Liam (Canadian French)', language: 'Canadian French' },
    { value: 'Remi', label: 'Rémi (French)', language: 'French' },
    { value: 'Lea', label: 'Léa (French)', language: 'French' },
    { value: 'Celine', label: 'Céline (French)', language: 'French' },
    { value: 'Mathieu', label: 'Mathieu (French)', language: 'French' },
    { value: 'Isabelle', label: 'Isabelle (Belgian French)', language: 'Belgian French' },
    { value: 'Bianca', label: 'Bianca (Italian)', language: 'Italian' },
    { value: 'Adriano', label: 'Adriano (Italian)', language: 'Italian' },
    { value: 'Giorgio', label: 'Giorgio (Italian)', language: 'Italian' },
    { value: 'Carla', label: 'Carla (Italian)', language: 'Italian' },
    { value: 'Carmen', label: 'Carmen (Romanian)', language: 'Romanian' },
    // Germanic
    { value: 'Sabrina', label: 'Sabrina (Swiss Standard German)', language: 'Swiss Standard German' },
    { value: 'Hannah', label: 'Hannah (Austrian German)', language: 'Austrian German' },
    { value: 'Vicki', label: 'Vicki (German)', language: 'German' },
    { value: 'Daniel', label: 'Daniel (German)', language: 'German' },
    { value: 'Marlene', label: 'Marlene (German)', language: 'German' },
    { value: 'Hans', label: 'Hans (German)', language: 'German' },
    { value: 'Lisa', label: 'Lisa (Belgian Dutch)', language: 'Belgian Dutch' },
    { value: 'Laura', label: 'Laura (Dutch)', language: 'Dutch' },
    { value: 'Lotte', label: 'Lotte (Dutch)', language: 'Dutch' },
    { value: 'Ruben', label: 'Ruben (Dutch)', language: 'Dutch' },
    // Nordic
    { value: 'Mads', label: 'Mads (Danish)', language: 'Danish' },
    { value: 'Naja', label: 'Naja (Danish)', language: 'Danish' },
    { value: 'Sofie', label: 'Sofie (Danish)', language: 'Danish' },
    { value: 'Ida', label: 'Ida (Norwegian)', language: 'Norwegian' },
    { value: 'Liv', label: 'Liv (Norwegian)', language: 'Norwegian' },
    { value: 'Elin', label: 'Elin (Swedish)', language: 'Swedish' },
    { value: 'Astrid', label: 'Astrid (Swedish)', language: 'Swedish' },
    { value: 'Suvi', label: 'Suvi (Finnish)', language: 'Finnish' },
    { value: 'Karl', label: 'Karl (Icelandic)', language: 'Icelandic' },
    { value: 'Dora', label: 'Dóra (Icelandic)', language: 'Icelandic' },
    // Slavic
    { value: 'Jitka', label: 'Jitka (Czech)', language: 'Czech' },
    { value: 'Maxim', label: 'Maxim (Russian)', language: 'Russian' },
    { value: 'Tatyana', label: 'Tatyana (Russian)', language: 'Russian' },
    { value: 'Ola', label: 'Ola (Polish)', language: 'Polish' },
    { value: 'Ewa', label: 'Ewa (Polish)', language: 'Polish' },
    { value: 'Maja', label: 'Maja (Polish)', language: 'Polish' },
    { value: 'Jacek', label: 'Jacek (Polish)', language: 'Polish' },
    { value: 'Jan', label: 'Jan (Polish)', language: 'Polish' },
    // Other
    { value: 'Gwyneth', label: 'Gwyneth (Welsh)', language: 'Welsh' },
    { value: 'Burcu', label: 'Burcu (Turkish)', language: 'Turkish' },
    { value: 'Filiz', label: 'Filiz (Turkish)', language: 'Turkish' },
    { value: 'Hiujin', label: 'Hiujin (Cantonese)', language: 'Cantonese' },
    { value: 'Zhiyu', label: 'Zhiyu (Chinese Mandarin)', language: 'Chinese Mandarin' },
    { value: 'Jihye', label: 'Jihye (Korean)', language: 'Korean' },
    { value: 'Seoyeon', label: 'Seoyeon (Korean)', language: 'Korean' },
    { value: 'Kazuha', label: 'Kazuha (Japanese)', language: 'Japanese' },
    { value: 'Tomoko', label: 'Tomoko (Japanese)', language: 'Japanese' },
    { value: 'Takumi', label: 'Takumi (Japanese)', language: 'Japanese' },
    { value: 'Mizuki', label: 'Mizuki (Japanese)', language: 'Japanese' },
    { value: 'Hala', label: 'Hala (Gulf Arabic)', language: 'Gulf Arabic' },
    { value: 'Zayd', label: 'Zayd (Gulf Arabic)', language: 'Gulf Arabic' },
    { value: 'Zeina', label: 'Zeina (Arabic)', language: 'Arabic' },
]);
export const DEFAULT_TTS_VOICE = 'Danielle';
export const TTS_VOICE_VALUES = new Set(TTS_VOICES.map((v) => v.value));
export function isValidTtsVoice(v) {
    return TTS_VOICE_VALUES.has(v);
}
/** Returns voices grouped by language for rendering <optgroup> elements. */
export function ttsVoicesByLanguage() {
    const groups = new Map();
    for (const v of TTS_VOICES) {
        const arr = groups.get(v.language) ?? [];
        arr.push(v);
        groups.set(v.language, arr);
    }
    return Array.from(groups.entries()).map(([language, voices]) => ({ language, voices }));
}
//# sourceMappingURL=tts-voices.js.map